import React, { useEffect } from 'react'
import { Alert, Box, Button, Typography } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login'
import { useSearchParams } from 'react-router-dom'
import useSignIn from '../../hooks/authentication/useSignIn'

const Login = () => {

  const [searchParams] = useSearchParams()
  const { data, isLoading, isSuccess, refetch } = useSignIn()
  
  const handleSignIn = async () => {
    refetch()
  }

  useEffect(() => {
    if (isSuccess) {
      window.location = data
    }
  }, [isSuccess])

  return (
    <Box
      sx={{
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {
        searchParams.get('errorMsg') && (
          <Alert severity='error' sx={{ mb: 2 }}>
            {decodeURIComponent(searchParams.get('errorMsg'))}
          </Alert>
        )
      }
      <Typography
        variant='h5'
        sx={{
          color: '#27417A',
          fontWeight: 'bold'
        }}
      >
        Welcome to the Novir &quot;INTRANET&quot;
      </Typography>
      <Button
        variant='contained'
        sx={{
          backgroundColor: '#3A6DAA',
          width: '65%',
          mt: 2
        }}
        onClick={handleSignIn}
        disabled={isLoading}
      >
        <LoginIcon sx={{ mr: 2 }}/>
            Sign In with Office 365
      </Button>
    </Box>
  )
}

export default Login